import type { HelpFile } from '../../types/help'
import { IdentitySelectorTestIds } from '../../../testids/IdentitySelectorTestIds'

// Symbolschalter in der Kopfleiste haben jeweils ein eigenes aria-label /
// Tooltip — ein Hilfesymbol daneben wäre nur Lärm. Der Convention-Check
// verlangt einen Eintrag pro statischer Testid; `null` ist die bewusste
// Opt-out-Variante.
export const identitySelectorHelp: HelpFile = {
  docPage: '/docs/getting-started/dashboard',
  texts: {
    [IdentitySelectorTestIds.btnLogout]: null,
    [IdentitySelectorTestIds.btnProfile]: null,
    [IdentitySelectorTestIds.btnSwitchUser]: null,
  },
}
